// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G9i4","name":"styles_name__32cvg","phone":"styles_phone__2KjDq"};